import React from 'react';
import FullScreenLoader from '../../shared/components/FullScreenLoader';
import { useTermOfUse } from '../../shared/hooks/useTermOfUse';
import './TermOfUse.css';

export interface TermOfUseProps {
    buttonText: string
}

const TermsOfService: React.FC<TermOfUseProps> = ({ buttonText }) => {
    const {isLoading, termofuse} = useTermOfUse();

    if (isLoading) return <FullScreenLoader />

    const htmlContent = termofuse?.result ? String(termofuse.result) : '';

    return (
        <>
            <h2>Условия использования</h2>
            <div className="terms-container"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
            >
            </div>
        </>
    );
};

export default TermsOfService;